module.exports = __webpack_public_path__ + "media/images/top/keisan_club_print-min-4bc44f2893127ad9482d67984e911cba.png";